import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Page } from '@/components/Page'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useAuth } from '@/auth/useAuth'
import { CategoriesPanel } from './components/CategoriesPanel'
import { WatchRulesPanel } from './components/WatchRulesPanel'

export function InboxSettingsPage() {
  const navigate = useNavigate()
  const { hasPermission } = useAuth()
  const canManageCategories = hasPermission('inbox.categories.manage')
  const canManageRules = hasPermission('inbox.rules.manage')

  return (
    <Page
      title="Inbox settings"
      description="Custom categories and watch-rules. Rules route mail and can trigger a workflow; nothing posts to your books until you accept it."
      actions={
        <Button variant="secondary" onClick={() => navigate('/inbox')}>
          <ArrowLeft className="size-4" />
          Back to inbox
        </Button>
      }
    >
      <CategoriesPanel canManage={canManageCategories} />
      <WatchRulesPanel canManage={canManageRules} />

      <Card>
        <CardHeader>
          <CardTitle>Email digests</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Periodic inbox digests run on the shared Workflow engine. Add a scheduled
            workflow with the inbox digest step from{' '}
            <Button variant="ghost" className="h-auto p-0 align-baseline" onClick={() => navigate('/workflows')}>
              Workflows
            </Button>{' '}
            to receive a summary email and in-app notification. AI summaries respect the
            tenant AI token quota and never post anything to your books.
          </p>
        </CardContent>
      </Card>
    </Page>
  )
}
